import { ChangeDetectionStrategy, Component, Inject, Input, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TypedFormGroup } from '@feature/forms/form-model';

@Component({
    selector: 'wai-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoadingIndicatorComponent {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  isFullScreen = false;
  @Input() message?: string;
  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any) {
    this.isFullScreen = dialogData?.isFullScreen;
  }
}
